import React from "react";

const ReferralFormProcessedCheckbox = ({ReferalProcess, ReferralChecked}) => {
    console.log("🚀 ~ file: ReferralFormProcessedCheckbox.js ~ line 4 ~ ReferralFormProcessedCheckbox ~ ReferralChecked", ReferralChecked)
    return (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
          }}
        >
          <input
            id="referral_processed"
            type="checkbox"
            defaultChecked={ReferralChecked}
            placehold="Referral Form Processed"
            checked={ReferralChecked}
            value={ReferralChecked}
            onChange={(e) => {
              ReferalProcess(e);
            }}
            
            style={{ marginRight: "10px" }}
          />
          <p style={{ fontSize: "16px" }}> Referral Form Processed</p>
        </div>
      )
};

export default ReferralFormProcessedCheckbox;